export default ({request}) => ({
  masterExpenseListApi(data = {}) {
    return request({
      url: '/master/masterExpense/list',
      method: 'post',
      data,
    })
  },
  masterExpenseDetailApi(data = {}) {
    return request({
      url: '/master/masterExpense/detail',
      method: 'post',
      data,
    })
  },
  masterExpenseSaveApi(data = {}) {
    return request({
      url: '/master/masterExpense/save',
      method: 'post',
      data,
    })
  },
  masterExpenseDelApi(data = {}) {
    return request({
      url: '/master/masterExpense/del',
      method: 'post',
      data,
    })
  },
})
